import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FotosService {

  constructor() { }
  dedicatoria;
  fotosfuera=[];
  fotosDentro=[];
 public agregarFotoFuera(foto){
    this.fotosfuera.push({foto: foto, frase:''});
  }
  public agregarFotoDentro(foto){
    this.fotosDentro.push({foto: foto, frase:''});
  }
}
